import { buildId } from '@/utils/build-id'
import { publicEnv } from '@/utils/public-env'

// The released version this deployment serves. Set per deploy, not baked into
// the image: one image is built per commit and promoted stage → prod, and the
// version is only assigned at promotion. Without it, the build id stands in
// (package.json's version on a local build, the commit in an image).
export const appVersion = publicEnv('NEXT_PUBLIC_APP_VERSION') || buildId
